import * as React from 'react'
import { InputText } from '../../atoms/input-text/input-text'
import { Button } from '../../atoms/button/button'
import { ModalValidKey } from '../../modals/modal-valid-key/modal-valid-key'
import { ModalInvalidKey } from '../../modals/modal-invalid-key/modal-invalid-key'
import ProductImage from '../../../assets/images/form/products-image.png'
import ProductImageEc from '../../../assets/images/form/Products-Ec.png'
import ProductImagePe from '../../../assets/images/form/Products-pe.png'
import CompetitionService from '../../../shared-campaign/services/competition'
import CollegeService from '../../../services/college-service'
import { Context } from '../../../context/app-context'
import {
  KEYS_PATTERN,
  concourseId,
  activityName,
  isActivityClose,
} from '../../../constants/activity-constants'
import { useForm } from 'react-hook-form'
import './form-register-keys.scss'

export const FormRegisterKeys = ({ setFormStep }) => {
  const { userParticipation, dispatch } = React.useContext(Context)
  const [isLoading, setIsLoading] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ mode: 'onSubmit' })
  const maxLimitDigits = process.env.LOCALE === 'es-EC' ?12 : 10;
  const setGeneralError = (error = 'Ha ocurrido una exepción inesperada') => {
    setError('key', {
      type: 'customError',
      message: error,
    })
  }

  const handleFinishModal = () => {
    setFormStep(2)
  }

  const handleSubmitModal = () => {
    reset()
    setShowModal(false)
  }

  const getUserParticipation = React.useCallback(() => {
    CollegeService.getUserParticipation({ concourseId }).then(response => {
      if (response.status === 200) {
        dispatch({
          type: 'set',
          payload: { userParticipation: response.data },
        })
      }
    })
  }, [dispatch])

  const onSubmit = ({ key }) => {
    if (isLoading) return
    setIsLoading(true)

    let payload = {
      activity: activityName,
      country: process.env.COUNTRY_CODE,
      key: {
        code: key,
      },
      detail: userParticipation?.schoolId || 'SIN_DETALLE',
    }

    // VALIDATE CODE IF IM ON EC
    let apiMethod = 'postRedeemKeyWithoutPoints';
    if (process.env.LOCALE === 'es-EC' && key.length === 12) {
      apiMethod = 'postRedeemKeyPromo12Digits';
    }


    CompetitionService[apiMethod](concourseId, payload)
      .then(response => {
        if (response.status === 200) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'Interacciones - Ingresa Tu Clave',
            category: 'cole challenge',
            action: 'click',
            label: 'registrar clave',
          })
          setShowModal('valid')
          getUserParticipation()
        } else {
          setShowModal('invalid')
        }
      })
      .catch(() => {
        setGeneralError()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return showModal === 'valid' ? (
    <ModalValidKey
      handleFinish={handleFinishModal}
      handleSubmit={handleSubmitModal}
    />
  ) : showModal === 'invalid' ? (
    <ModalInvalidKey
      handleFinish={handleFinishModal}
      handleSubmit={handleSubmitModal}
    />
  ) : (
    <div className="f-form-keys">
      <div className="f-form-keys__header">
        <img
          src={process.env.LOCALE === "es-EC" ? ProductImageEc : process.env.LOCALE === "es-PE" ? ProductImagePe : ProductImage}
          alt="productos nosotras"
          className="f-form-keys__header__icon"
        />

        <h3 className="f-form-keys__header__title">
          NO OLVIDES GUARDAR TUS EMPAQUES <br />
          <b>¡ES MUY IMPORTANTE!</b>
        </h3>

        <div className="f-form-keys__header__description">
          {
            process.env.LOCALE === "es-EC" ?
              <>
                <p>
                  Recuerda que al final de la actividad, debes entregar todos los empaques para recibir tu premio.
                </p>
                <p>
                  Además,{' '}
                  <b>
                    con tu ayuda Nosotras reciclamos, reducimos y reutilizamos por un planeta más sostenible.
                  </b>
                </p>
              </>
              :
              <>
                <p>
                  Recuerda que al final de la actividad, tanto para tu participación
                  individual como para la de tu colegio, los debes entregar para
                  recibir tu premio.
                </p>
                <p>
                  Además,{' '}
                  <b>
                    con tu ayuda Nosotras reciclamos, reducimos y reutilizamos por un
                    planeta más sostenible.
                  </b>
                </p>
              </>
          }
        </div>
      </div>

      <form className="f-form-keys__body" onSubmit={handleSubmit(onSubmit)}>
        <Button
          color="white"
          type="button"
          onClick={handleFinishModal}
          text={
            <>
              <i className="far fa-angle-left" /> Regresar
            </>
          }
          className="f-form-keys__body__back-button"
        />

        {/*TODO agregar servicio para validar cierre de concurso*/}
        {
          isActivityClose ?
            <div className="f-form-keys__body__fields">
              <p>Lo sentimos, nuestro concurso ya ha finalizado</p>
            </div>
            :
            <>
              <div className="f-form-keys__body__fields">
                <h2 className="f-form-keys__body__fields__title">INGRESA TU CLAVE</h2>

                <InputText
                  name="key"
                  label="CLAVE"
                  placeholder="45KA56"
                  className="f-form-keys__body__fields__field"
                  register={register}
                  errors={errors}
                  validations={{
                    required: 'Este campo es requerido',
                    minLength: {
                      value: 10,
                      message: 'La clave debe tener 10 dígitos',
                    },
                    pattern: {
                      value: KEYS_PATTERN,
                      message: 'Clave inválida',
                    },
                    onChange: e => {
                      let newValue = e.target?.value.slice(0, maxLimitDigits).replace(/\s/g, '')
                      setValue(e.target.name, newValue)
                    },
                  }}
                />

              </div>

              <Button
                color="pink"
                type="submit"
                text="REGISTRAR CLAVE"
                className="f-form-keys__body__button"
                isLoading={isLoading}
              />
            </>
        }
      </form>
    </div>
  )
}
